<template>
  <a
    href="#"
    class="customer-support-action"
    @click.prevent="zendesk_open_chat({ cta_id })"
  >
    <slot> </slot>
  </a>
</template>

<script>
/**
 * Centralized CTA wrapper that activates customer support (currently Zendesk
 * chat). Replaces the scattered `@click.prevent="$openZendeskChat()"` pattern
 * and the `javascript:window.openZendeskChat()` links previously embedded in
 * v-html strings.
 *
 * Usage:
 *
 *   <customer-support-action cta_id="prefooter-webchat">
 *     Chatta ora
 *   </customer-support-action>
 *
 * Tracking: handled inside `zendesk_open_chat` (see
 * src/utilities/integrations/zendesk.js). The component just forwards the
 * `cta_id` so the Rybbit event carries the CTA location/identifier:
 *   - `support:chat:activate` on successful open
 *   - `support:chat:fail` when the SDK is unavailable
 */
import { zendesk_open_chat } from "@/utilities/integrations/zendesk";

export default {
  name: "customer-support-action",

  props: {
    /**
     * Identifier of this CTA (where in the UI it lives). Forwarded to the
     * Rybbit event as `cta_id` so the dashboard can break clicks down by
     * location. Defaults to 'unknown' when not provided.
     */
    cta_id: {
      type: String,
      default: "unknown",
    },
  },

  methods: {
    zendesk_open_chat,
  },
};
</script>
